export default "__VITE_ASSET__DWSFZojt__"